import { getIsAQuoteTemplate } from 'Cube/domain/postActionStages/utils/getIsQuoteATemplate'
import {
  CubeReducerState,
  DisabledReasonType,
  VisibleEnabledFeatureAvailable
} from 'modules/Cube/domain/cube.domain.types'
import { objectsAreEqualIgnoreUndefined } from '@sequencehq/utils'
import { getCriticalPathData } from 'modules/Cube/domain/postActionStages/queries/availableFeatures/utils/hasCubeBeenUpdated'
import { hasPresentationChanged } from 'Cube/view/layouts/quote/QuoteEditorContent/utils/presentation'

export const getSaveTemplateAvailable = (
  prevState: CubeReducerState
): VisibleEnabledFeatureAvailable => {
  const available =
    getIsAQuoteTemplate(prevState) && !prevState.data.common.isArchived

  if (!available) {
    return {
      available: {
        visible: false,
        enabled: false
      },
      reasons: [
        {
          reasonType: DisabledReasonType.InvalidStatus,
          metadata: { status: prevState.data.common.status }
        }
      ]
    }
  }

  if (prevState.editor.savingDraft) {
    return {
      available: {
        visible: true,
        enabled: false
      },
      reasons: [
        {
          reasonType: DisabledReasonType.SavingInProgress,
          metadata: {}
        }
      ]
    }
  }

  /**
   * Use critical-path comparison only — not `hasCubeBeenUpdated`, which treats
   * missing start dates as "changed". Quote templates never have a start date.
   */
  const criticalPathChanged = !objectsAreEqualIgnoreUndefined(
    getCriticalPathData(prevState.initialData),
    getCriticalPathData(prevState.data)
  )

  const enabled =
    criticalPathChanged ||
    hasPresentationChanged(
      prevState.initialData.presentation,
      prevState.data.presentation
    )

  return {
    available: {
      visible: true,
      enabled: enabled
    },
    reasons: enabled
      ? []
      : [{ reasonType: DisabledReasonType.NoChangesMade, metadata: {} }]
  }
}
